/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * クレジットカード情報<br/> 支払方法にクレジットカードを指定した場合は設定を必須とする。<br/> ※一度中断した後の再実行でもDxAPIの実行や予約基本情報の更新で必要なため、指定を必須とする。
 */
export interface PaymentRequestPaymentCard {
  /**
   * 予約基本情報利用カード種別<br/> 処理内で利用する予約基本情報のカードの種別を指定する。<br/> 項目が設定されなかった場合は、新規カード情報の利用であると判定する。<br/> 支払方法がクレジットカードである、かつクレジットカード番号を設定しない場合は設定を必須とする。<br/> 設定された値に対応するカード情報は以下とする。<br/> paymentCard1：いつもの情報の一般用クレジットカード1<br/> paymentCard2：いつもの情報の一般用クレジットカード2
   */
  registeredCardType?: PaymentRequestPaymentCard.RegisteredCardTypeEnum;
  /**
   * クレジットカード番号<br/> 利用するカード情報が新規カード情報である場合は設定を必須とする。<br/> 数字11～16桁
   */
  cardNumber?: string;
  /**
   * クレジットカード名義<br/> 英数字半角空白40桁以内
   */
  holderName: string;
  /**
   * クレジットカード有効期限(形式：yyyyMM)<br/> 先頭数字4桁、後続数字01～12
   */
  expiryDate: string;
  /**
   * セキュリティコード(CVV)<br/> UATPカードにはCVVが存在しないため、UATPカード利用時はCVVの設定を不要とする。<br/> また、外部サイトでの認証結果により支払を承認する場合も設定を不要とする。<br/> 数字3～4桁
   */
  cvv?: string;
  /**
   * UATPカードであるか<br/> 支払利用カードがUATPカードである場合、trueを設定する。<br/> 値が設定されない場合、falseが設定されたものとして扱う。
   */
  isUatpCard?: boolean;
  /**
   * 予約基本情報更新要否<br/> 予約基本情報を更新する場合、true設定する。<br/> 値が設定されない場合、falseが設定されたものとして扱う。<br/>
   */
  saveAsBasicReservationInformation?: boolean;
}
export namespace PaymentRequestPaymentCard {
  export type RegisteredCardTypeEnum = 'paymentCard1' | 'paymentCard2';
  export const RegisteredCardTypeEnum = {
    PaymentCard1: 'paymentCard1' as RegisteredCardTypeEnum,
    PaymentCard2: 'paymentCard2' as RegisteredCardTypeEnum,
  };
}
